function registerGeneralOptionsPlugin({
  i18n: { __ },
  element: { useState },
  data: { dispatch, withSelect },
  components: { ToggleControl },
  editor: { PluginDocumentSettingPanel },
  blockEditor: { useSettings },
}) {
  const GeneralOptionSettings = ({ postMeta }) => {
    const [enableTransparentHeadingToggle] = useSettings(
      `custom.generalOptions.enableTransparentHeadingToggle`,
      ['custom.generalOptions.enableTransparentHeadingToggle'],
    );
    const { is_enable_transparent_header: isEnableTransparentHeaderMetaValue } =
      postMeta;

    const [isEnableTransparentHeader, setIsEnableTransparentHeader] = useState(
      isEnableTransparentHeaderMetaValue,
    );

    const onMetaUpdate = (field, value) => {
      const postId = wp.data.select('core/editor').getCurrentPostId();
      // update metadata.
      dispatch('core/editor').editPost({
        id: postId,
        meta: {
          [field]: value,
        },
      });
    };

    return (
      <PluginDocumentSettingPanel
        className="common-general-option"
        name="common-general-option"
        title={__('General Options', '')}
        initialOpen={true}
      >
        {enableTransparentHeadingToggle && (
          <div className="components-base-control">
            <label
              htmlFor="enable-transparent-header"
              className={'components-base-control__label'}
            >
              Transparent header
            </label>
            <ToggleControl
              id="enable-transparent-header"
              label={__('Disable | Enable')}
              checked={isEnableTransparentHeader}
              onChange={(value) => {
                setIsEnableTransparentHeader(value);
                onMetaUpdate('is_enable_transparent_header', value);
              }}
            />
          </div>
        )}
      </PluginDocumentSettingPanel>
    );
  };

  const GeneralOptions = (props) => {
    const { postType } = props;
    const [generalOptions] =
      useSettings(`custom.generalOptions`, ['custom.generalOptions']) || {};
    let showGeneralOption = false;
    for (const option in generalOptions) {
      if (generalOptions[option]) {
        showGeneralOption = true;
      }
    }
    if (!postType || !showGeneralOption) {
      return null;
    }
    return <GeneralOptionSettings {...props} />;
  };
  return withSelect((select) => {
    const postMeta = select('core/editor').getEditedPostAttribute('meta') || {};
    return {
      postMeta,
      postType: select('core/editor').getCurrentPostType(),
    };
  })(GeneralOptions);
}

wp.domReady(() => {
  if (wp.editPost) {
    wp.plugins.registerPlugin('common-general-options', {
      render: registerGeneralOptionsPlugin(wp),
      icon: 'editor-table',
    });
  }
});
